import React from "react";

export const Features = () => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
        <h2 style={{ color: '#FF6A00' }}>¿Por qué elegir el Comercio Automatizado?</h2>
       
        </div>

        {/* Primera fila: Texto y máquina expendedora */}
        <div className="row align-items-center">
          {/* Texto de características */}
          <div className="col-md-6 order-2 order-md-1 text-left">
            <div className="features-list">


              

              {/* Espacio entre la primera y segunda sección */}
              <div style={{ marginBottom: '-10px' }}></div> {/* Agregado un espacio entre las secciones */}

              <p style={{ fontSize: '2rem' }}>
                <strong>
                  Al hacer la transición al Comercio Automatizado, los minoristas pueden beneficiarse de lo siguiente:
                </strong>
              </p>
              <ul>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-clock" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Disponibilidad de productos 24/7
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-dollar-sign" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Menores costos operativos
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-bullhorn" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Mayor exposición de la marca y productos
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-map-marker-alt" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Presencia en ubicaciones donde el comercio minorista tradicional no está disponible
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-chart-line" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Mayor volumen de ventas
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-trophy" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Obtención de una ventaja competitiva
                </li>
              </ul>

              {/* Espacio entre la primera y segunda sección */}
              <div style={{ marginBottom: '100px' }}></div> {/* Agregado un espacio entre las secciones */}

              <strong style={{ fontSize: '2rem', marginBottom: '20px'  }}>
                Al adquirir nuestras ofertas de comercio automatizado en tiendas, los minoristas pueden aprovechar:
              </strong>
              <p></p>
              <ul>
                <li style={{ fontSize: '1.5rem', marginBottom: '10px'  }}>
                  <i className="fas fa-tablet-alt" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Mejora en la experiencia del cliente: la orientación mediante pantalla táctil garantiza que el comprador elija el producto correcto en ausencia de experiencia en la tienda.
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-box" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Reducción de pérdidas de inventario: el método tradicional de guardar productos es ineficiente para los clientes y laborioso para los minoristas.
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-database" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Mejor control de inventario
                </li>
                <li style={{ fontSize: '1.5rem', marginBottom: '20px'  }}>
                  <i className="fas fa-clock" style={{ color: '#FFA500', marginRight: '10px', fontSize: '1.8rem' }}></i>
                  Tiempo de servicio reducido
                </li>
              </ul>
            </div>
          </div>

          {/* Imagen de la máquina */}
          <div className="col-md-6 order-1 order-md-2">
             <div className="machine-image" style={{ marginTop: '-80px' }}>  {/* Ajusta el valor según necesites */}
           
              <img
                src="./img/features_vending.png"
                alt="Máquina expendedora"
                className="img-responsive"
              />
            </div>
          </div>
        </div>

        {/* Segunda fila: Texto explicativo e infografía */}
        <div className="row align-items-center">
          {/* Texto explicativo */}
          <div className="col-md-6 order-2 order-md-1 text-left">
            {/* Aquí puedes agregar texto explicativo adicional si lo necesitas */}
          </div>

          
        </div>
      </div>
    </div>
  );
};
